export default {
      id: "ic_responsible_gaming_menu-usage",
      viewBox: "1.38 1.31 19.27 21.65",
      url: "/" + "images/icons.3.109.2.svg#ic_responsible_gaming_menu-usage",
      toString: function () {
        return this.url;
      }
    }